// @file Add a global reference to the tldraw editor object.
import window from '@@/bits/global'
import type { Editor } from 'tldraw'

/** @deprecated Use `const { editor } = useTldrawEditor()` instead. */
function getEditorObject(): Editor | null {
  return window.$tldrawEditor ?? null
}

export { getEditorObject }
